import { IState } from "../store";
import { IUserAccount, IUserInfo, ILocation } from "./interfaces";

export function selectCurrentUser(state: IState): IUserInfo {
	return state.user.user;
}

export function selectAccounts(state: IState): Array<IUserAccount> {
	return state.user.accounts;
}

interface ISelectUser {
    user: IUserInfo;
    accounts: IUserAccount[];
}

export function selectUser(state: IState): ISelectUser {
	return {
		user: state.user.user,
		accounts: state.user.accounts,
	};
}

export function selectLocation(state: IState): ILocation {
	return {
		...state.user.location,
	};
}

export function selectUserSettingsValue(state: IState, key: string): boolean | number | string | object {
	const userSettings = state.user.settings;

	const itemOut = userSettings?.filter(item => item.title === key)[0];

	return itemOut?.data?.value;
}
